import { useSelector } from 'react-redux';

import { makeSelectWhoami } from 'containers/Auth_old/selectors';
import useUserPermissions from 'hooks/useUserPermissions';

export default function useDocumentDownloadsAccess() {
  const whoami = useSelector(makeSelectWhoami());
  const { downloadApplicantDocumentsPermission, exportsPermission } =
    useUserPermissions();
  const enabled =
    whoami.feature_flags?.['hire-bulk-applicant-documents-download'] === true;
  return {
    canOpenPage: enabled && !!downloadApplicantDocumentsPermission,
    canSeeExports: !enabled || !!exportsPermission,
  };
}
